// internal-deps
import Analytics, { DEFAULT_ANALYTICS_CONTEXT_VALUE, getAnalyticsConfigParams } from "@swiggy-private/analytics";
import { SwiggyHeaders } from "@swiggy-private/js-utils/dist/fetch/types";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

// constants
import { ANALYTICS_HOST } from "../constants/index";

export const getAnalyticsContextValue = (headers?: GetSwiggyHeadersResponsePayload | SwiggyHeaders | null) => {
    const analyticsConfig = getAnalyticsConfigParams(headers ?? {}, ANALYTICS_HOST);
    const analytics = (analyticsConfig && new Analytics(analyticsConfig)) || DEFAULT_ANALYTICS_CONTEXT_VALUE;
    return analytics;
};
